export default class ModalCSS {
    constructor() {
        this.display = null;
        this.paddingLeft = null;
        this.paddingRight = null;
    }
    toString() {
        let css = "";
        for (const [prop, value] of Object.entries(this)) {
            if (value == null) {
                continue;
            }
            css += `${prop.replace(/([A-Z])/g, (a, b) => "-" + a.toLowerCase())}: ${this[prop]}; `;
        }
        return css.trim();
    }
}
